var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIAttendancetextlogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 432,
    height: 57,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 69,
    width: 432,
    height: 57
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-103 -69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7845 40.2254C24.7845 36.2263 23.3157 32.5851 20.9582 29.9685 18.576 27.3394 15.3175 25.7102 11.701 25.7102L11.701 42.1755C11.701 50.1984 17.5762 56.6907 24.7968 56.6907L24.7968 40.2254 24.7845 40.2254Z",
    fill: "#EC1C24",
    transform: "matrix(1 0 0 1.00393 103 69.0434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7845 27.5863 24.7351 40.176C24.7474 36.6953 23.3527 33.5479 21.0816 31.2645 18.8105 28.981 15.6754 27.5493 12.1947 27.5369 10.4791 27.4752 8.86217 27.0802 7.38103 26.4137 3.01166 24.4265-0.0246857 20.0201 0 14.8978L6.46766 14.9225C10.0471 14.9349 13.7376 14.5769 17.1319 15.9593 21.3778 17.6873 24.3401 21.9333 24.7351 26.4754 24.7721 26.8457 24.7845 27.216 24.7845 27.5863Z",
    fill: "#B5020B",
    transform: "matrix(1 0 0 1.00393 103 69.0434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1934 13.0217C21.7851 13.0217 24.7104 10.1088 24.7104 6.51703 24.7104 2.92526 21.7851 0 18.1934 0 14.6016 0 11.6763 2.91291 11.6763 6.51703 11.6763 10.1211 14.6016 13.0217 18.1934 13.0217Z",
    fill: "#EC1C24",
    transform: "matrix(1 0 0 1.00393 103 69.0434)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.9097 55.9749 67.3673 46.2734 51.0871 46.2734 47.6187 55.9749 38.2629 55.9749 54.4937 15.4286 63.9607 15.4286 80.1298 55.9749 70.9097 55.9749ZM53.6667 39.1515 64.7877 39.1515 59.221 23.7847 53.6544 39.1515 53.6667 39.1515Z",
    fill: "#333333",
    transform: "matrix(1 0 0 1.00393 103 69.0434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.259 15.4286 110.259 22.6615 98.2615 22.6615 98.2615 55.9749 89.4857 55.9749 89.4857 22.6615 77.4885 22.6615 77.4885 15.4286 110.271 15.4286 110.259 15.4286Z",
    fill: "#333333",
    transform: "matrix(1 0 0 1.00393 103 69.0434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.547 15.4286 145.547 22.6615 133.55 22.6615 133.55 55.9749 124.774 55.9749 124.774 22.6615 112.789 22.6615 112.789 15.4286 145.559 15.4286 145.547 15.4286Z",
    fill: "#333333",
    transform: "matrix(1 0 0 1.00393 103 69.0434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.901 48.7419 179.971 48.7419 179.971 55.9749 152.126 55.9749 152.126 15.4286 179.416 15.4286 179.416 22.6615 160.914 22.6615 160.914 32.3136 177.145 32.3136 177.145 39.6823 160.914 39.6823 160.914 48.7419 160.901 48.7419Z",
    fill: "#333333",
    transform: "matrix(1 0 0 1.00393 103 69.0434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.05 15.4286 220.826 15.4286 220.826 55.9749 212.927 55.9749 197.152 30.5486 197.152 55.9749 188.377 55.9749 188.377 15.4286 196.523 15.4286 212.063 40.5586 212.063 15.4286 212.05 15.4286Z",
    fill: "#333333",
    transform: "matrix(1 0 0 1.00393 103 69.0434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.486 15.4286C260.99 15.4286 268.26 24.2537 268.26 35.7943 268.26 47.3349 260.99 55.9749 248.486 55.9749L231.429 55.9749 231.429 15.4286 248.486 15.4286ZM248.486 48.7419C255.756 48.7419 259.472 42.7433 259.472 35.7943 259.472 28.8453 255.744 22.6615 248.486 22.6615L240.217 22.6615 240.217 48.7419 248.486 48.7419Z",
    fill: "#333333",
    transform: "matrix(1 0 0 1.00393 103 69.0434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.733 55.9749 299.191 46.2734 282.898 46.2734 279.43 55.9749 270.086 55.9749 286.317 15.4286 295.784 15.4286 311.953 55.9749 302.733 55.9749ZM285.49 39.1515 296.599 39.1515 291.045 23.7847 285.478 39.1515 285.49 39.1515Z",
    fill: "#333333",
    transform: "matrix(1 0 0 1.00393 103 69.0434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.626 15.4286 349.402 15.4286 349.402 55.9749 341.502 55.9749 325.728 30.5486 325.728 55.9749 316.952 55.9749 316.952 15.4286 325.099 15.4286 340.638 40.5586 340.638 15.4286 340.626 15.4286Z",
    fill: "#333333",
    transform: "matrix(1 0 0 1.00393 103 69.0434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.35 35.6709C357.35 24.2537 367.138 14.725 379.456 14.725 386.837 14.725 393.28 18.0206 397.193 23.1429L390.503 27.6727C388.047 24.4265 384.381 22.427 379.765 22.427 371.878 22.427 366.126 28.4379 366.126 35.6709 366.126 42.9038 371.804 48.9765 379.703 48.9765 384.369 48.9765 388.035 46.9769 390.491 43.7431L397.181 48.2729C393.268 53.3952 386.825 56.6907 379.444 56.6907 367.126 56.6907 357.338 47.2114 357.338 35.6709L357.35 35.6709Z",
    fill: "#333333",
    transform: "matrix(1 0 0 1.00393 103 69.0434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.918 48.7419 432 48.7419 432 55.9749 404.155 55.9749 404.155 15.4286 431.432 15.4286 431.432 22.6615 412.93 22.6615 412.93 32.3136 429.161 32.3136 429.161 39.6823 412.93 39.6823 412.93 48.7419 412.918 48.7419Z",
    fill: "#333333",
    transform: "matrix(1 0 0 1.00393 103 69.0434)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIAttendancetextlogo);
export default __webpack_public_path__ + "static/media/iAttendance text logo.219b88163af947b334a46eb59501d9f6.svg";
export { ForwardRef as ReactComponent };